module.exports = __webpack_public_path__ + "fonts/unicons.a4c968c8.woff2";